<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-1" [routerLink]="['/on-demand/load-profile']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-9">
      <h2 class="col pb-2 m-0 title">
        {{ "LOAD_PROFILE_DATA" | translate }}
        {{ "DETAILS" | translate }}
      </h2>
      <h6 class="col subtitle">
        {{ "ONDEMANDLOADPROFILE_SUBTITLE" | translate }}
      </h6>
    </div>
    @if (
      authService.isAuthorized([PermissionEnum.Ondemand_loadprofile_download])
    ) {
      <div
        class="col-md-2 d-flex justify-content-end align-items-center gap-2 pe-5"
      >
        <div class="download-button ps-3 pe-3 pb-2 pt-1" (click)="download()">
          <svg-icon
            alt="Download"
            class="hover-effect"
            src="assets/core/table/download.svg"
          ></svg-icon>
        </div>
      </div>
    }
  </div>
  <div #tableContainer class="table-container mt-5">
    <table>
      <thead>
        <tr>
          <td class="custom-width">
            {{ "TIME" | translate | uppercase }}
          </td>
          <td colspan="2">{{ "ACTIVE" | translate }} {{ "ENERGY" | translate }}</td>
          <td colspan="2">{{ "REACTIVE" | translate }} {{ "ENERGY" | translate }}</td>
          <td colspan="2">{{ "APPARENT" | translate }} {{ "ENERGY" | translate }}</td>
          <td colspan="3">{{ "INSTANTANEOUSVOLTAGE" | translate }}</td>
          <td colspan="3">{{ "INSTANTANEOUSCURRENT" | translate }}</td>
          <td colspan="3" class="custom-width">{{ "POWERFACTOR" | translate }}</td>
          <td class="custom-width">{{ "FREQUENCY" | translate }}</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td class="table-name-number">
            <span>{{ item.meterTime | date: "dd MMM yyyy, h:mm a" }}</span>
          </td>

          <!-- Active Energy -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.activeEnergyImport + ' WH'">
              {{ item.activeEnergyImport  == null ? "N/A" :
                item.activeEnergyImport | unitConverter: "WH"
              }}</span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.activeEnergyExport + ' WH'">
              {{ item.activeEnergyExport == null ? "N/A" :
                item.activeEnergyExport | unitConverter: "WH"
              }}</span>
            </div>
          </td>

          <!-- Reactive Energy -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.reactiveEnergyImport + ' VARH'">
              {{ item.reactiveEnergyImport == null ? "N/A" :
                item.reactiveEnergyImport | unitConverter: "VARH"
              }}</span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.reactiveEnergyExport + ' VARH'">
              {{ item.reactiveEnergyExport == null ? "N/A" :
                item.reactiveEnergyExport | unitConverter: "VARH"
              }}</span>
            </div>
          </td>

          <!-- Apparent Energy -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.apparentEnergyImport + ' VAH'">
              {{ item.apparentEnergyImport == null ? "N/A" :
                item.apparentEnergyImport | unitConverter: "VAH"
              }}</span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.apparentEnergyExport + ' VAH'">
              {{ item.apparentEnergyExport == null ? "N/A" :
                item.apparentEnergyExport | unitConverter: "VAH"
              }}</span>
            </div>
          </td>

          <!-- Voltage -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Line 1" src="assets/load-profile/l1.svg" />
              <span [attr.title]="item.instantaneousVoltageL1 + ' V'"
                >{{ item.instantaneousVoltageL1 == null ? "N/A" :
                   (item.instantaneousVoltageL1 | number: "1.0-4") + ' V' }}</span
              >
            </div>
          </td>
          <td class="mid-cell">
            <div class="cell">
              <img alt="Line 2" src="assets/load-profile/l2.svg" />
              <span [attr.title]="item.instantaneousVoltageL2 + ' V'"
                >{{ item.instantaneousVoltageL2 == null ? "N/A" :
                   (item.instantaneousVoltageL2 | number: "1.0-4") + ' V' }}</span
              >
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Line 3" src="assets/load-profile/l3.svg" />
              <span [attr.title]="item.instantaneousVoltageL3 + ' V'"
                >{{ item.instantaneousVoltageL3 == null ? "N/A" :
                   (item.instantaneousVoltageL3 | number: "1.0-4") + ' V' }}</span
              >
            </div>
          </td>

          <!-- Current -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Line 1" src="assets/load-profile/l1.svg" />
              <span [attr.title]="item.instantaneousCurrentL1 + ' A'"
                >{{ item.instantaneousCurrentL1 == null ? "N/A" :
                   (item.instantaneousCurrentL1 | number: "1.0-4") + ' A' }}</span
              >
            </div>
          </td>
          <td class="mid-cell">
            <div class="cell">
              <img alt="Line 2" src="assets/load-profile/l2.svg" />
              <span [attr.title]="item.instantaneousCurrentL2 + ' A'"
                >{{ item.instantaneousCurrentL2 == null ? "N/A" :
                   (item.instantaneousCurrentL2 | number: "1.0-4") + ' A' }}</span
              >
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Line 3" src="assets/load-profile/l3.svg" />
              <span [attr.title]="item.instantaneousCurrentL3 + ' A'"
                >{{ item.instantaneousCurrentL3 == null ? "N/A" :
                   (item.instantaneousCurrentL3 | number: "1.0-4") + ' A' }}</span
              >
            </div>
          </td>

          <!-- Power Factor -->
          <!-- <td>
            <span [attr.title]="item.instantaneousPowerFactor">{{
              item.instantaneousPowerFactor! | number: "1.0-4"
            }}</span>
          </td> -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Line 1" src="assets/load-profile/l1.svg" />
              <span [attr.title]="item.instantaneousPowerFactorL1"
                >{{ item.instantaneousPowerFactorL1 == null ? "N/A" :
                   item.instantaneousPowerFactorL1 | number: "1.0-4" }}</span
              >
            </div>
          </td>
          <td class="mid-cell">
            <div class="cell">
              <img alt="Line 2" src="assets/load-profile/l2.svg" />
              <span [attr.title]="item.instantaneousPowerFactorL2 "
                >{{ item.instantaneousPowerFactorL2 == null ? "N/A" :
                   item.instantaneousPowerFactorL2 | number: "1.0-4" }}</span
              >
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Line 3" src="assets/load-profile/l3.svg" />
              <span [attr.title]="item.instantaneousPowerFactorL3 "
                >{{ item.instantaneousPowerFactorL3 == null ? "N/A" :
                   item.instantaneousPowerFactorL3 | number: "1.0-4" }}</span
              >
            </div>
          </td>

          <!-- Frequency -->
          <td>
            <span [attr.title]="item.instantaneousFrequency"
              >{{ item.instantaneousFrequency  == null ? "N/A" :
                 (item.instantaneousFrequency | number: "1.0-4") + ' Hz' }}</span
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="container-down">
    <app-pagination
      [lastPageSize]="lastPageSize"
      [numberOfDevices]="numberOfCommands"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      (pageChange)="pageChange($event)"
    ></app-pagination>
  </div>
</div>
